import ComplaintPopup from "components/Organismos/ComplaintPopup";
import L from 'leaflet';
import { FeatureGroup, Marker, Popup } from "react-leaflet";
import { ComplaintProperties } from "store/modules/complaints/types";
import complaintPin from '_assets/imgs/mapa/map-icon-red.png';

type ComplaintsMapLayerProps = {
    features: GeoJSON.Feature<GeoJSON.Point, ComplaintProperties>[];
    hideButtons?: boolean;
    onViewClick?: (properties: ComplaintProperties, point: GeoJSON.Point) => void | Promise<void>;
}

const complaintIcon = L.icon({
    iconUrl: complaintPin,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const ComplaintsMapLayer = ({
    features,
    hideButtons,
    onViewClick
}: ComplaintsMapLayerProps) => {
    return (
        <FeatureGroup>
            {features.map(feat => (
                <Marker
                    key={`marker-manifestacao-${feat.properties.Id}`}
                    icon={complaintIcon}
                    position={[feat.geometry.coordinates[1], feat.geometry.coordinates[0]]}
                >
                    <Popup>
                        <ComplaintPopup
                            title={feat.properties.Titulo}
                            complaintType={feat.properties.Name}
                            hideButtons={hideButtons}
                            onViewClick={() => onViewClick?.(feat.properties, feat.geometry)}
                        />
                    </Popup>
                </Marker>
            ))}
        </FeatureGroup>
    )
}
export default ComplaintsMapLayer